import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./TileContent.html';
import styles from './tile-content-hashed.scss';
import layout from '../../../layouts/LayoutFactory';

export default layout('TileContent', cssUtil.hashTemplate(template, styles), function (partial) {
    partial('Item', cssUtil.hashTemplate('<div class="<%= gwTileContentItem %>" gw-partial-target></div>', styles));
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/tiles/tileLayout/Content/TileContent.js
// module id = 2040
// module chunks = 0